
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			parentScrollHeight: 0,
			parentClientHeight: 0,
			parentScrollTop: 0,
			parentScrollWidth: 0,
			parentClientWidth: 0,
			parentScrollLeft: 0,
			parent: null as any as HTMLElement,
			isDragging: false,
			offsetY: 0,
			offsetX: 0,
		};
	},
	props: {
		isHorizontal: {
			type: Boolean
		},
		parentScrollRef: {
			type: HTMLElement,
			required: false,
		}
	},
	computed: {
		widthPercent():number {
			return this.parentClientWidth / this.parentScrollWidth;
		},
		width():number {
			let val = this.parentClientWidth * this.widthPercent - 10;
			if (val < 40) {
				return 40;
			}
			return val;
		},
		left():number {
			return this.parentScrollLeft * (1 + this.widthPercent);
		},
		heightPercent():number {
			return this.parentClientHeight / this.parentScrollHeight;
		},
		height():number {
			let val = this.parentClientHeight * this.heightPercent;
			val - 10;
			if (val < 40) {
				return 40;
			}
			return val;
		},
		maxScrollTop():number {
			return this.parentScrollHeight - this.parentClientHeight;
		},
		maxScrollLeft():number {
			return this.parentScrollWidth - this.parentClientWidth;
		},
		verticalRight():number {
			return -this.parentScrollLeft;
		},
		horizontalBottom():number {
			return -this.parentScrollTop;
		},
		hidden():boolean {
			if (!this.isHorizontal) {
				if (this.parentClientHeight >= this.parentScrollHeight) {
					return true;
				}
			} else if (this.parentClientWidth >= this.parentScrollWidth) {
				return true;
			}
			return false;
		},
	},
	watch: {
		parentScrollRef: {
			immediate: true,
			handler(newValue:HTMLElement | null, oldValue:HTMLElement | null){
				if (!oldValue && newValue){
					this.parentScrollRef.addEventListener("scroll", this.onParentScroll);
				}else if (oldValue && !newValue) {
					oldValue.removeEventListener("scroll", this.onParentScroll);
				}
			}
		}
	},
	methods: {
		onScroll() {
			this.parentScrollTop = this.parent.scrollTop;
			if (this.parentScrollRef){
				this.onParentScroll();
			}else{
				this.parentScrollLeft = this.parent.scrollLeft;
			}
			if (!this.isHorizontal) {
				this.onScrollVertical();
			} else {
				this.onScrollHorizontal();
			}
		},
		getThumb():HTMLDivElement {
			return this.$refs.thumb as any as HTMLDivElement;
		},
		getLeft():number{
			let left =  this.parentScrollLeft * (1 + this.widthPercent);
			let max = this.parentScrollWidth - this.width;
			if (left > max) {
				left = max;
			}
			return left;
		},
		getTop():number{
			let top = this.parentScrollTop * (1 + this.heightPercent);
			let max = this.parentScrollHeight - this.height;
			if (top > max) {
				top = max;
			}
			return top;
		},
		onScrollVertical() {
			let top = this.getTop();
			let thumb = this.getThumb();
			if (!thumb) {
				return;
			}
			thumb.style.transform = `translateY(${top}px)`;
			thumb.style.height = this.height + "px";
			thumb.style.right = this.verticalRight + "px";
		},
		onScrollHorizontal() {
			let left = this.getLeft();
			let thumb = this.getThumb();
			if (!thumb) {
				return;
			}
			thumb.style.transform = `translateX(${left}px)`;
			thumb.style.width = this.width + "px";
			thumb.style.bottom = this.horizontalBottom + "px";
		},
		async refreshData() {
			if (this.parent != this.$parent?.$el) {
				this.parent = this.$parent?.$el as HTMLElement;
				this.parent.addEventListener("scroll", this.onScroll);
			}
			this.parentScrollTop = this.parent.scrollTop;
			this.parentClientHeight = this.parent.clientHeight;
			this.parentScrollHeight = this.parent.scrollHeight;
			this.parentScrollLeft = this.parent.scrollLeft;
			this.parentClientWidth = this.parent.clientWidth;
			this.parentScrollWidth = this.parent.scrollWidth;
			this.onParentScroll();

			let thumb = this.getThumb();
			if (!thumb) {
				return;
			}
			if (this.isHorizontal) {
				thumb.style.transform = `translateX(${this.getLeft()}px)`;
				thumb.style.width = this.width + "px";
				thumb.style.bottom = this.horizontalBottom + "px";
			} else {
				thumb.style.transform = `translateY(${this.getTop()}px)`;
				thumb.style.height = this.height + "px";
				thumb.style.right = this.verticalRight + "px";
			}
		},
		onMouseDown(event:MouseEvent) {
			this.offsetY = event.screenY;
			this.offsetX = event.screenX;
			this.isDragging = true;
		},
		onMouseUp(event:MouseEvent) {
			this.isDragging = false;
		},
		onMouseMove(event:MouseEvent) {
			if (!this.isDragging) {
				return;
			}

			if (this.isHorizontal) {
				let deltaX = event.screenX - this.offsetX;
				this.offsetX = event.screenX;
				let scrollLeft = parseInt((this.parent.scrollLeft + (deltaX / this.widthPercent)).toFixed(0));
				if (scrollLeft < 0) {
					scrollLeft = 0;
				}
				if (scrollLeft > this.maxScrollLeft) {
					scrollLeft = this.maxScrollLeft;
				}
				this.parent.scrollLeft = scrollLeft;
			} else {
				let deltaY = event.screenY - this.offsetY;
				this.offsetY = event.screenY;
				let scrollTop = parseInt((this.parent.scrollTop + (deltaY / this.heightPercent)).toFixed(0));
				if (scrollTop < 0) {
					scrollTop = 0;
				}
				if (scrollTop > this.maxScrollTop) {
					scrollTop = this.maxScrollTop;
				}
				this.parent.scrollTop = scrollTop;
			}
		},
		onParentScroll(){
			if (!this.parentScrollRef) return;
			if (!this.isHorizontal){
				this.parentScrollLeft = -(this.parentScrollRef.scrollWidth - this.parentScrollRef.clientWidth) + this.parentScrollRef.scrollLeft;
				this.onScrollVertical();
			}
		},
	},
	mounted() {
		window.addEventListener("mousemove", this.onMouseMove);
		window.addEventListener("mouseup", this.onMouseUp);
		this.$parent?.$el.addEventListener("mousemove", this.refreshData);
	},
	destroyed() {
		window.removeEventListener("mousemove", this.onMouseMove);
		window.removeEventListener("mouseup", this.onMouseUp);
		if (this.parentScrollRef){
			this.parentScrollRef.removeEventListener("scroll", this.onParentScroll);
		}
		this.$parent?.$el.removeEventListener("mousemove", this.refreshData);
	}
});
